import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

export default function useQueryString() {
  const { search } = useLocation();
  return !search ? undefined : queryString.parse(search);
}
